module.exports = __webpack_public_path__ + "static/img/zone-active.5cb4e27.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/sachassou/visuels/zone-active.png
// module id = 2WV/
// module chunks = 1